import {gql} from 'apollo-angular';

export function createMeeting(fields: string[]) {
  return gql`
    mutation createMeeting($meeting: MeetingDto!) {
      createMeeting(meeting: $meeting) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function updateMeeting(fields: string[]) {
  return gql`
    mutation updateMeeting($meeting: MeetingDto!) {
      updateMeeting(meeting: $meeting) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function retrieveMeetingsByMonth(fields: string[]) {
  return gql`
    query retrieveMeetingsByMonth($month: Int!, $year: Int!) {
      retrieveMeetingsByMonth(month: $month, year: $year) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function retrieveMeetingById(fields: string[]) {
  return gql`
    query retrieveMeetingById($id: String!) {
      retrieveMeetingById(id: $id) {
        ${fields.join('\n')}
      }
    }
  `;
}
